export { default, cloudflareLoader } from './CloudflareResizedImage';
